import { mockData, getMockData } from './Mock';
import { SalesOverview } from '../../models/Dashboard';

export const mock = true;

// 模拟销售概览数据
const mockOverview: SalesOverview = {
    monthTime: new Date(),
    monthPaidOrderAmount: 156789.50,
    monthChargeAmount: 200000.00,
    monthWithdrawAmount: 50000.00,
    monthFinishedOrderAmount: 145678.90
};

// 模拟历史数据
const mockHistory: SalesOverview[] = Array.from({ length: 6 }).map((_, index) => {
    const date = new Date();
    date.setMonth(date.getMonth() - index);
    return {
        monthTime: date,
        monthPaidOrderAmount: 150000 + Math.random() * 50000,
        monthChargeAmount: 180000 + Math.random() * 40000,
        monthWithdrawAmount: 40000 + Math.random() * 20000,
        monthFinishedOrderAmount: 140000 + Math.random() * 30000
    };
}).reverse(); // 反转数组使其按时间正序

mockData.set('GET_OVERVIEW', mockOverview);
mockData.set('GET_OVERVIEW_HISTORY', mockHistory);

export { getMockData }; 